import "./consent-message-checkbox.scss";

const initConsentMessageCheckbox = () => {
  const $consentCheckboxContainer = document.querySelector(".consent-message-container");
  if (!$consentCheckboxContainer) return;
  const $linksWithScrollToBottom = $consentCheckboxContainer.querySelectorAll(
    "a[data-scroll-to-bottom='true']"
  );
  $linksWithScrollToBottom.forEach(link => {
    if (!link) return;
    link.addEventListener("click", event => {
      event.preventDefault();
      const { scrollToBottomContainer } = link.dataset;
      if (scrollToBottomContainer) {
        const container = document.querySelector(scrollToBottomContainer);
        if (container) {
          container.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      } else {
        window.scrollTo({
          top: document.body.scrollHeight,
          behavior: "smooth"
        });
      }
    });
  });
};

document.addEventListener("DOMContentLoaded", initConsentMessageCheckbox);
